import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../Auth/ProvideAuth'
import { ROOT_PATH } from '../Config/constants.js';

import { Alert } from '@mui/material';

import { myLog } from "../Services/Functions";
import Api from "../Services/Api";

function TokenLogin() {
    const [currentOrder, setCurrentOrder] = useState(null);
    const [errorLogin, setErrorLogin] = useState("");
    const [displayAlert, setDisplayAlert] = useState(null);
    
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const order = searchParams.get('order');
    const page = searchParams.get('page');

	let navigate = useNavigate();
	let auth = useAuth();
    
    const setCurrentOrderFromBe = async () => {
        try {
            await Api.get({endpoint: 'manage/currentOrder', contentType : 'application/json'})
                .then(response => {
                    setCurrentOrder(response.data.currentOrder);
                    return true;
                })
                .catch(error => {
                    myLog(JSON.stringify(error));
                    return false;
                });
		} catch (error) {
			myLog(JSON.stringify(error));
            return false;
		}
    }
    
    useEffect(() => {
        const performLogin = async () => {
            try {
                let response = await auth.tokenSignin(token);

                if (response.status === 401) {
                    setErrorLogin("Nome utente o password non validi");
                    setDisplayAlert(-1);
                    return;
                }
                if (response.status !== 200) {
                    setErrorLogin("Si è verificato un errore imprevisto. Riprovare più tardi");
                    setDisplayAlert(-1);
                    return;
                }
                
                Api.post({endpoint: `manage/switchToExternalOrder`, body: { 'order_id': order }, contentType : 'application/json'})               
					.then(response => {
						setDisplayAlert(1);
						//let timer1 = setTimeout(() => {setLoading(false);clearTimeout(timer1)}, 3000);
                        setCurrentOrderFromBe();
					})
					.catch(error => {
						if (error.response.status === 422) {
							var errors = JSON.parse(error.request.response);
							if (errors.hasOwnProperty('errors')) {
								var alertMessage = "Si sono verificati errori nei dati:";
								for (var errorField in errors.errors) {
									alertMessage += "\n" + errors.errors[errorField].join(',');
								}
								alert(alertMessage);
								setDisplayAlert(0);
							}
							else {
								myLog(error);
							}
							return;
						}
						else {
							myLog(error);
							alert("Errore inatteso!");
						}
						setDisplayAlert(-1);
					});

                navigate(ROOT_PATH + "/" + page);

            } catch (error) {
                myLog(JSON.stringify(error));
            }
        };

        performLogin();
    }, []); 	// eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            Login in corso...
            
            {displayAlert === 1 && (
                <Alert severity="info">Clicca sul link che ti abbiamo inviato via email per attivare l'account</Alert>
            )}
            {(displayAlert === -1 || displayAlert === -2) && (
                <Alert severity="error">{errorLogin}</Alert>
            )}            
        </>
    );
}

export default TokenLogin;